const addIndustryArr = (industryArr) => {
    return {
        type: "ADD_INDUSTRY_ARR",
        industryArr
    }
}

const removeIndustryArr = () => {
    return {
        type: "REMOVE_INDUSTRY_ARR"
    }
}

export {
    addIndustryArr,
    removeIndustryArr
}


